import { useEffect } from 'react';
import { fcmApi } from '@/services/fcm/fcm.service.ts';

/**
 * Registers the device's FCM token once the user is authenticated.
 *
 * The `enabled` flag must be true before the hook will hit the backend - the
 * `/fcm/tokens/available` endpoint is auth-protected, so calling it before the
 * current-user query resolves produces a 401 that gets reported to Sentry.
 */
export const useFirebaseNotifications = (enabled: boolean) => {
  useEffect(() => {
    if (!enabled) return;

    const setupFcm = async () => {
      const existing = await fcmApi.checkExistingToken().catch((err) => {
        // 401 here means the session ended between mount and this call -
        // benign, the redirect to login handles it elsewhere.
        if (err?.response?.status !== 401) console.error(err);
        return null;
      });
      if (!existing) {
        await fcmApi.createFcmToken();
      }
    };
    setupFcm();
  }, [enabled]);
};
